module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACMAAAAjCAYAAAAe2bNZAAAABmJLR0QAAAAAAAD5Q7t/AAAACXBIWXMAAA3XAAAN1wFCKJt4AAAAB3RJTUUH4gEIDwMOqEUojwAAAHtJREFUWMPt1DEKwCAMBVDTU3sXzyZuHsPfJYKINYtpO/y3qPATRNQQiIiIyAZAAEQAGUDTMQKQV/MarFirc4FrXne4E6fmfnk9sp08NXfJi4Zbnz9dKRG5huYu+V5QjPtdjPWRfN9MMsLJWJ/L/+o1DQXf/zNERES0dgM/GUjEINwBuAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/img/more_dots.png
// module id = 492
// module chunks = 0